import { render } from "./banner-hero.vue?vue&type=template&id=db64671e"
import script from "./banner-hero.vue?vue&type=script&lang=js"
export * from "./banner-hero.vue?vue&type=script&lang=js"

import "./banner-hero.vue?vue&type=style&index=0&id=db64671e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__